<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="product in selects"
      :key="product.id"
      :value="product.id"
      :selected="product.id == selected"
      >{{ product.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectProducts',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    productsNotAppear: {
      type: Array,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/product/all`).then((res) => {
        if (this.productsNotAppear) {
          res.data.forEach((data) => {
            if (this.productsNotAppear.indexOf(data.id) == -1) {
              this.selects.push(data);
            }
          });
        } else {
          this.selects = res.data;
        }
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
